import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

import {IAuditDropdownOption} from "./audit-facet.component";
import {AuditGridView} from "./models/audit-grid-view.enum";
import {TranslationService} from "@services/translation.service";

type TranslationFn = (value: string) => string;
const pipe = (
    initialValue: AuditGridView,
    ...fns: TranslationFn[]
) => fns.reduce(
    (previousValue, fn) => fn(previousValue),
    initialValue,
);


@Component({
    selector: 'climb-audit-type-select',
    template: `
        <climb-typeahead
            [(model)]="model"
            [resultFormatter]="auditTypeFormatter"
            [search]="searchAuditType"
            [required]="required"
            [disabled]="disabled"
            [keyFormatter]="auditTypeKeyFormatter"
            [keySearch]="searchAuditTypeByKey"
            [namespace]="'auditType'"
            placeholder="Choose Section"
            (selectItem)="selectItemHandler($event)"
            #typeahead
        ></climb-typeahead>
    `
})
export class AuditTypeSelectComponent {
    @Input() model: AuditGridView = AuditGridView.ChooseSection;
    @Input() required: boolean;
    @Input() disabled: boolean;
    @Input() options: IAuditDropdownOption[] = [];
    @Input() largeAnimalEnabled = false;

    @Output() onChange: EventEmitter<AuditGridView> = new EventEmitter<AuditGridView>();

    placeholder: string;

    constructor(
        private translationService: TranslationService,
    ) { }

    selectItemHandler(item: IAuditDropdownOption): void {
        this.onChange.emit(item.viewName);
    }

    searchAuditType = (search: string): Promise<IAuditDropdownOption[]> => {
        const result = this.options.filter(o =>
            this.translateViewName(o.viewName).toLowerCase().includes(search.toLowerCase())
            && o.isOptionVisible
        );

        return Promise.resolve(result);
    }

    searchAuditTypeByKey = (search: string): Promise<IAuditDropdownOption[]> => {
        const result = this.options.filter(o =>
            o.viewName.toLowerCase().includes(search.toLowerCase())
            && o.isOptionVisible
        );

        return Promise.resolve(result);
    }

    auditTypeFormatter = (value: IAuditDropdownOption): string => {
        return this.translateViewName(value.viewName);
    }

    auditTypeKeyFormatter = (value: AuditGridView): string => {
        return value;
    }

    translate = (searchValue: string) => (source: string): string => {
        return source.replace(searchValue, this.translationService.translate(searchValue));
    };

    largeAnimalTranslate = (searchValue: string, resultValue: string) => (source: string): string => {
        return this.largeAnimalEnabled && source === searchValue
            ? resultValue
            : source;
    };

    translateViewName = (gridView: AuditGridView): string => {
        return pipe(
            gridView,
            this.translate('Institutions'),
            this.translate('Institution'),
            this.translate('Studies'),
            this.translate('Study'),
            this.translate('Jobs'),
            this.translate('Job'),
            this.translate('Lines'),
            this.translate('Line'),
            this.largeAnimalTranslate('Clinical Observation Details', 'Health Observations'),
        );
    }
}
